import sileo from 'sileo';

const RecruitmentBoardPermission = new sileo.Model('hqzen', 'recruitment-board-permission');
const JobPostingPermission = new sileo.Model('hqzen', 'job-posting-permission');
const RecruitmentNotes = new sileo.Model('hqzen', 'recruitment-notes');
const RecruitmentTodos = new sileo.Model('hqzen', 'recruitment-update-todo');
const ScheduledInterview = new sileo.Model('hqzen', 'recruitment-scheduled-interview');
const RecruitmentCards = new sileo.Model('hqzen', 'recruitment-job-posting-applications');
const RecruitmentJobOffer = new sileo.Model('hqzen', 'recruitment-job-offer');
const RecruitmentJobOfferEmploymentContracts = new sileo.Model('hqzen', 'recruitment-job-offer-employment-contracts');
const RecruitmentJobOfferEmploymentContract = new sileo.Model('hqzen', 'recruitment-job-offer-employment-contract');
const JobPostingApplicationMessageThread = new sileo.Model('hqzen', 'recruitment-message-thread');
const RecruitmentMessageThreadAttachments = new sileo.Model('hqzen', 'recruitment-message-thread-attachments');
const RecruitmentJobActionHistory = new sileo.Model('hqzen', 'recruitment-job-action-history');
const EvaluateEmploymentContractsSignatureCompletion = new sileo.Model(
    'hqzen', 'evaluate-employment-contracts-signature-completion');
const ApplicationCardChannel = new sileo.Model('hqzen', 'application-card-channel');
const InterviewHistory = new sileo.Model('hqzen', 'interview-history');
const NonAddedApplicationHistoryChecker = new sileo.Model('hqzen', 'non-added-application-history-checker');
const ApplicantApplicationSearch = new sileo.Model('hqzen', 'recruitment-applicant-search');
const RecruitmentNoteAttachmentFormData = new sileo.Model('hqzen', 'recruitment-note-attachment-amazon-form-data');
const RecruitmentNoteAttachmentUpdateResource = new sileo.Model('hqzen', 'recruitment-note-attachment-update');

const actions = {
    fetchInterviewHistory(context, filters) {
        return InterviewHistory.objects.filter(filters);
    },

    fetchRecruitmentBoardPermissionEmployees(context, filters) {
        return RecruitmentBoardPermission.objects.filter(filters);
    },

    fetchApplicationCardChannel(context, filters) {
        return ApplicationCardChannel.objects.filter(filters);
    },

    revokeRecruitmentBoardAccess(context, pk) {
        return RecruitmentBoardPermission.objects.update({ pk: pk });
    },

    fetchJobPostingPermission(context, data) {
        return JobPostingPermission.objects.filter({}, data);
    },

    getJobPostingPermission(context, pk) {
        return JobPostingPermission.objects.get(pk);
    },

    updateJobPostingPermission(context, data) {
        let form = new FormData();
        for (let key of Object.keys(data)) {
            form.append(key, data[key]);
        }
            return JobPostingPermission.objects.update({}, form);
    },

    createRecruitmentBoardPermission(context, data) {
        const form = new FormData();

        for (let field in data) {
            form.append(field, data[field]);
        }

        return RecruitmentBoardPermission.objects.create(form);
    },

    createScheduledInterview(context, data) {
        const form = new FormData();

        for (let key in data) {
            form.append(key, data[key]);
        }

        return ScheduledInterview.objects.create(form);
    },

    updateScheduledInterview(context, data) {
        const form = new FormData();

        const filters = { pk: data.pk };
        for (let key in data) {
            if (key !== 'pk') {
                form.append(key, data[key]);
            }
        }

        return ScheduledInterview.objects.update(filters, form);
    },

    getScheduledInterviewDetails(context, pk) {
        return ScheduledInterview.objects.get(pk);
    },

    createOrUpdateRecruitmentNote(context, data) {
        const form = new FormData();

        for (let key in data) {
            form.append(key, data[key]);
        }
        return RecruitmentNotes.objects.create(form);
    },

    getRecruitmentNote(context, pk) {
        return RecruitmentNotes.objects.get(pk);
    },

    updateRecruitmentTodo(context, filters) {
        return RecruitmentTodos.objects.update(filters);
    },

    fetchRecruitmentCards(context, filters) {
        return RecruitmentCards.objects.filter(filters);
    },

    createRecruitmentApplication(context, data) {
        return RecruitmentCards.objects.create(data);
    },

    fetchRecruitmentJobOffer(context, pk) {
        return RecruitmentJobOffer.objects.get(pk);
    },

    fetchRecruitmentJobOfferEmploymentContracts(context, pk) {
        return RecruitmentJobOfferEmploymentContracts.objects.get(pk);
    },

    fetchRecruitmentJobOfferEmploymentContract(context, pk) {
        return RecruitmentJobOfferEmploymentContract.objects.get(pk);
    },

    fetchJobPostingApplicationMessageThread(context, pk) {
        return JobPostingApplicationMessageThread.objects.get(pk);
    },

    fetchRecruitmentMessageThreadAttachments(context, filters) {
        return RecruitmentMessageThreadAttachments.objects.filter(filters);
    },

    fetchRecruitmentApplicationHistory(context, filters) {
        return RecruitmentJobActionHistory.objects.filter(filters);
    },

    evaluateEmploymentContractsSignatureCompletion(context, filters) {
        return EvaluateEmploymentContractsSignatureCompletion.objects.filter(filters);
    },

    fetchApplicantsInJobPosting(context, filters) {
        return ApplicantApplicationSearch.objects.filter(filters);
    },

    fetchApplicationWithAddedHistoryFlag(context, pk) {
        return NonAddedApplicationHistoryChecker.objects.get(pk);
    },

    fetchRecruitmentNoteAmazonFormData(context, filters) {
        return RecruitmentNoteAttachmentFormData.objects.filter(filters).then(data => {
            return data.amazon;
        });
    },

    updateRecruitmentNoteAttachments(context, data) {
        const form = new FormData();

        for (let key in data) {
            form.append(key, data[key]);
        }
        return RecruitmentNoteAttachmentUpdateResource.objects.update({}, form);
    },

};

export default {
    namespaced: true,
    actions,
};
